import React, { PureComponent } from 'react';
import { TXT_PAGE_NOT_FOUND } from 'config/txt';
import './PageNotFoundScreen.scss';

export default class PageNotFoundScreen extends PureComponent {
    render() {
        return (
            <div className='PageNotFoundScreen'>
                <h2>
                    {TXT_PAGE_NOT_FOUND}
                </h2>
            </div>
        );
    }
}
